__turbopack_context__.v({
  "className": "uGQpLG_className",
  "variable": "uGQpLG_variable",
});
